import React, { useState, useMemo } from 'react';

function OptionToggle({ checked = false, onChange = () => {}, disabled = false, ariaLabel = '', size = 20, onColor = '#60b43c', offColor = '#555' }) {
  const [focused, setFocused] = useState(false);
  const width = size * 2;
  const height = size;
  const knobSize = Math.max(8, size - 4);

  const translateX = useMemo(() => (width - knobSize - 4), [width, knobSize]);

  const containerStyle = {
    width,
    height,
    borderRadius: height / 2,
    background: checked ? onColor : offColor,
    opacity: disabled ? 0.45 : 1,
    position: 'relative',
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'background 140ms ease, box-shadow 120ms ease',
    display: 'inline-block',
    outline: focused ? '3px solid rgba(96,180,60,0.18)' : 'none',
    boxShadow: focused ? '0 0 0 3px rgba(96,180,60,0.06)' : 'none',
    padding: 2,
    border: 'none',
    verticalAlign: 'middle'
  };

  const knobStyle = {
    width: knobSize,
    height: knobSize,
    borderRadius: '50%',
    background: '#fff',
    position: 'absolute',
    top: 2,
    left: 2,
    transform: checked ? `translateX(${translateX}px)` : 'translateX(0px)',
    transition: 'transform 140ms cubic-bezier(.2,.9,.2,1)',
    boxShadow: '0 2px 6px rgba(0,0,0,0.25)'
  };

  const onClick = (e) => {
    e.preventDefault();
    if (disabled) return;
    onChange(!checked);
  };

  const onKeyDown = (e) => {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      style={containerStyle}
    >
      <span style={knobStyle} aria-hidden="true" />
    </button>
  );
}

export default OptionToggle;
